import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Accordion,
} from "@mui/material";
import EditBranch from "./EditBranch"; // Import your EditBranch component
import { createBranch, getBranches } from "../../firebase/firebase.utils";

function BranchListModal({ sponsorId, open, onClose, branches, setBranches }) {
  const [loading, setloading] = useState(false);

  const getSponsorBranches = async () => {
    const data = await getBranches(sponsorId);

    setBranches(data);
  };

  useEffect(() => {
    getSponsorBranches();
  }, []);

  const handleAddBranch = async () => {
    const newBranchData = {
      city: "",
      location: "",
      province: "San José",
      canton: "",
      district: "",
      countries: "",
      latitude: "",
      longitude: "",
      geopoint: "",
      cdate: new Date(),
    };
    await createBranch(sponsorId, newBranchData);
    getSponsorBranches();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            // backgroundColor: theme.palette.secondary.secondary,
            width: "100%",
            backgroundImage: "none",
            overflowX: "hidden",
          },
        }}
      >
        <DialogTitle>
          Sucursales
          <Button onClick={handleAddBranch} color="primary">
            Crear Sucursal
          </Button>
        </DialogTitle>
        <DialogContent sx={{ minHeight: "65vh", height: "65vh" }}>
          {branches.map((branch, index) => (
            <EditBranch
              sponsorId={sponsorId}
              key={index}
              data={branch}
              index={index}
              getSponsorBranches={getSponsorBranches}
            />
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Volver
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BranchListModal;
